
    <div class="container">
  <div class="top">
      <!-- <div class="title">Votre colis est en cours de livraison</div> -->
      <div class="title">{{titleMap}}
        <p class="subtitle">Dernière mise à jour il y a {{minLeft}} min</p>
      </div>
      <img class="quit_cross" src="assets/images/quit_cross.svg" (click)="onNoClick()">
     
   <!--  </div>-->  
        
    <!-- si isTousFacteurAccounts <div id="map-container-tft" *ngIf="isTousFacteurAccounts"> 
    </div>-->
    <div id='error-msg'></div>
      <div id="map-container" *ngIf="!isTousFacteurAccounts">
    <app-cartographie-mapbox [accessToken]="accessToken" [data]="data" [isTousFacteurAccounts]="isTousFacteurAccounts" ></app-cartographie-mapbox>      
      </div>

      
</div>
